import { useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Default company info as fallback
const DEFAULT_COMPANY_INFO = {
  name: "Nessenius Garten & Landschaftsbau",
  owner: "Lennard Nessenius",
  address: {
    street: "Alte Straße 17",
    zip: "37176",
    city: "Nörten-Hardenberg",
    country: "Deutschland"
  },
  contact: {
    phone: "+49 176 55669090",
    email: "nesseniusgartenservice@gmail.com"
  },
  hours: {
    monday: "08:00 - 18:00",
    tuesday: "08:00 - 18:00",
    wednesday: "08:00 - 18:00",
    thursday: "08:00 - 18:00",
    friday: "08:00 - 18:00",
    saturday: "09:00 - 14:00",
    sunday: "Geschlossen"
  }
};

export const useCompanyInfo = () => {
  const [companyInfo, setCompanyInfo] = useState(DEFAULT_COMPANY_INFO);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/site-content/contact_info`);
        if (response.ok) {
          const data = await response.json();
          if (data && data.content) {
            const c = data.content;
            // Map API response to expected format
            setCompanyInfo({
              name: c.company_name || DEFAULT_COMPANY_INFO.name,
              owner: c.owner || DEFAULT_COMPANY_INFO.owner,
              address: {
                street: c.address || DEFAULT_COMPANY_INFO.address.street,
                zip: c.zip_city?.split(' ')[0] || DEFAULT_COMPANY_INFO.address.zip,
                city: c.zip_city?.split(' ').slice(1).join(' ') || DEFAULT_COMPANY_INFO.address.city,
                country: "Deutschland"
              },
              contact: {
                phone: c.phone || DEFAULT_COMPANY_INFO.contact.phone,
                email: c.email || DEFAULT_COMPANY_INFO.contact.email
              },
              hours: {
                monday: c.opening_hours?.mo_fr || DEFAULT_COMPANY_INFO.hours.monday,
                tuesday: c.opening_hours?.mo_fr || DEFAULT_COMPANY_INFO.hours.tuesday,
                wednesday: c.opening_hours?.mo_fr || DEFAULT_COMPANY_INFO.hours.wednesday,
                thursday: c.opening_hours?.mo_fr || DEFAULT_COMPANY_INFO.hours.thursday,
                friday: c.opening_hours?.mo_fr || DEFAULT_COMPANY_INFO.hours.friday,
                saturday: c.opening_hours?.sa || DEFAULT_COMPANY_INFO.hours.saturday,
                sunday: c.opening_hours?.so || DEFAULT_COMPANY_INFO.hours.sunday
              }
            });
          }
        }
      } catch (error) {
        console.error('Error fetching company info:', error);
        // Keep default on error
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyInfo();
  }, []);

  return { companyInfo, loading };
};

export default useCompanyInfo;
